import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import LoadingButton from '../fw/LoadingButton.react.js';
import AcceptInvitationMutation from './AcceptInvitationMutation';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import mutationError from '../channel-defs/mutationError';
import LastOrganisationId from '../app/LastOrganisationId';

import './Invitations.scss';
import { User } from '../../common/types/types';

const messages = defineMessages({
    invalidTitle: {id: 'invitationView.invalid.title', 'defaultMessage': 'Invitation is invalid'},
    title: {id: 'invitationView.title', 'defaultMessage': 'Invitation'}
});

interface InvitationAcceptProps {
    intl: IntlShape;
    secret?: string;
    user: User;
}

class InvitationAccept extends React.Component<InvitationAcceptProps> {

    typeName = 'invitations';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        secret: PropTypes.string,
        user: PropTypes.object.isRequired,
    };

    static contextTypes = {
        router: PropTypes.object
    };

	constructor(props) {
		super(props);

		document.body.classList.add('InvitationAccept');
	}

	componentWillUnmount() {
		document.body.classList.remove('InvitationAccept');
	}

	componentWillMount() {
		if (this.props.user.invitationToAccept && this.props.user.invitationToAccept.length > 0) {
			const data = this.props.user.invitationToAccept[0];
			const secret = this.props.secret;

			let onFailure = (transaction) => {
				mutationError(transaction);
			};

			let onSuccess = () => {
				LastOrganisationId.set(data.organisation.realId);
				window.location.href = `${window.location.origin}/organisations/${data.organisation.realId}/`;
			};

			Relay.Store.commitUpdate(new AcceptInvitationMutation({invitation: data, secret: secret}), {
				onFailure,
				onSuccess
			});
		}
	}

	onClickHome() {
		return new Promise(() => {
			this.context.router.replace('/');
		});
	}

    render() {
        let { invitationToAccept } = this.props.user;

        if (!invitationToAccept || invitationToAccept.length === 0) {
            return (
                <AppPanel title={this.props.intl.formatMessage(messages.invalidTitle)}>
                    <div className="event-page invalidInvitation">
                        <h2><FormattedMessage defaultMessage="Invitation has already been used (or was invalid, can't tell)." id="acceptInvitation.invalid.description"/></h2>

						<LoadingButton className="btn btn-primary" onClick={() => this.onClickHome()}><FormattedMessage defaultMessage="Go home" id="invitation.goHome" /></LoadingButton>
                    </div>
                </AppPanel>
            );
        }

        return null;
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(InvitationAccept), (props) => {
    return props.user.invitationToAccept;
}), {
    initialVariables: {
        secret: '',
        invitationId: ''
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                invitationToAccept(id: $invitationId, secret: $secret) {
                    id,
                    organisation {
                        id,
                        realId,
                        name
                    },
                    email,
                    permissions,
                    createdAt,
                }
            }
        `,
    },
});
